import { Button } from "@/components/ui/Button"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog"

interface ConfirmationDialogProps {
  open: boolean
  title: string
  message: string
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmationDialog({
  open,
  title,
  message,
  onConfirm,
  onCancel,
}: ConfirmationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent className="tw-max-w-lg">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="tw-py-4">
          <p className="tw-text-sm tw-text-gray-600">{message}</p>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={onConfirm}
            className="tw-min-w-[75px]"
          >
            Yes
          </Button>
          <Button
            variant="default"
            onClick={onCancel}
            className="tw-min-w-[75px]"
          >
            No
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
